import React, { useState } from "react";
import { Box, Button, Card, Divider, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const imageUrl = process.env.REACT_APP_BASH_IMG_URL;

function Checkout() {

    const { state } = useLocation();
    const product = state?.product;
    const quantity = state?.quantity || 1;
    const total = state?.total || product.price * quantity;
    const [paymentMethod, setPaymentMethod] = useState("gateway");

    return (

        <Box sx={{ maxWidth: 1000, margin: "40px auto", display: "flex", gap: 4 }}>
            <Paper sx={{ flex: 1, p: 3 }}>
                <Typography variant="h5">Checkout</Typography>
                <Divider sx={{ my: 2 }} />

                <Card sx={{ p: 2 }}>
                    <img src={product.images[0].image} width={120} />
                    <Typography mt={2}>{product.name}</Typography>
                    <Typography>Qty : {quantity}</Typography>
                    <Typography fontWeight="bold">₹ {total}</Typography>
                </Card>
            </Paper>

            <Paper sx={{ width: 400, p: 3 }}>

                <Typography variant="h6">Payment Method</Typography>

                <RadioGroup value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                    <FormControlLabel value="gateway" control={<Radio />} label="Payment Gateway (Card / UPI / Wallet)" />
                    <FormControlLabel value="upi" control={<Radio />} label="UPI" />
                    <FormControlLabel value="qr" control={<Radio />} label="QR Code" />
                    <FormControlLabel value="bank" control={<Radio />} label="Net Banking" />
                </RadioGroup>

                <Divider sx={{ my: 2 }} />

                {paymentMethod === "qr" && (
                    <Box textAlign="center">
                        <img src="/images/payment-qr.png" width={220} alt="QR Code" />
                        <Typography mt={2}>Scan this QR using any UPI App</Typography>
                    </Box>
                )}

                {paymentMethod === "upi" && (
                    <Box>
                        <Typography>UPI ID</Typography>
                        <Typography fontWeight="bold" color="green">company@okicici</Typography>
                    </Box>
                )}

                {paymentMethod === "bank" && (
                    <Box>
                        <Typography>Bank Name : SBI</Typography>
                        <Typography>A/C Number : XXXXXXXX</Typography>
                        <Typography>IFSC : SBIN000XXXX</Typography>
                    </Box>
                )}

                {paymentMethod === "gateway" && (
                    <Button variant="contained" fullWidth size="large" sx={{ mt: 2 }}>Pay ₹ {total}</Button>
                )}
            </Paper>
        </Box>

    );

}

export default Checkout;